export default __webpack_public_path__ + "static/4_36-213acaf23d22228096592ba1e3ea1b70.png";